import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import { DatePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import { stableSort, getSorting, isNullOrEmpty} from '../Common/helpers';
import { validateForm, blurValidations } from '../Common/formValidator';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import AutoSug from '../Common/AutoSug/AutoSug';

import { API } from '../../ws/constants';

import './style.css';

var moment = require('moment');

function filters(data, inputValue){
    const arr_input = inputValue.split(" ");
    const fullLabel = data.CellPhone ? data.FullName.toLowerCase() + " " + data.CellPhone : data.FullName.toLowerCase();

    for(let i=0, n=arr_input.length;i<n;i++){
        if(fullLabel.indexOf(arr_input[i]) >= 0){
            return true;
        }
    }
    return false;
}

const FIELD = {
    CLIENT_INPUT: "CLIENT_INPUT",
    STAFF_INPUT: "STAFF_INPUT",
    CLIENT_FILTER: "CLIENT_FILTER",
    STAFF_FILTER: "STAFF_FILTER",
}

class Payments extends Component {
    /* START Constructor */

    constructor(props) {
        super(props);
        const today = moment();
        const Payments = this.props.loginData.profile.Payments;
        
        this.state = {
            editable: (this.props.isAdmin || (Payments && Payments.permission === 1))
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,returnType: 1
            ,searchStaff:""
            ,fetchStores:null
            ,fetchStaff:null
            ,fetchClients:null
            ,fetchPayments:null
            ,fetchPaymentTypes:null
            ,openModal:false
            ,paymentId: "New"
            ,paymentType: "1"
            ,storeInput: !isNullOrEmpty(sessionStorage.getItem("paymentsStoreInput")) ? sessionStorage.getItem("paymentsStoreInput") : "1"
            ,clientInputId: ""
            ,staffInputId: !isNullOrEmpty(sessionStorage.getItem("paymentsStaffInputId")) ? sessionStorage.getItem("paymentsStaffInputId") : ""
            ,dateInput: today
            ,value: ""
            ,notes: ""
            ,clientInputSearch: ""
            ,staffInputSearch: !isNullOrEmpty(sessionStorage.getItem("paymentsStaffInputName")) ? sessionStorage.getItem("paymentsStaffInputName") : ""
            // filter Stuff
            ,order:'asc'
            ,orderBy:'Name'
            ,page:0
            ,rowsPerPage:!isNullOrEmpty(sessionStorage.getItem("paymentsRowsPerPage")) ? parseInt(sessionStorage.getItem("paymentsRowsPerPage"), 10) : 25
            ,loading:false
            ,tableLoading:false
            ,dateName: "Hoje"
            ,storeFilter: [""]
            ,clientFilterId: ""
            ,staffFilterId: ""
            ,dateFilter: today
            ,clientFilterSearch: ""
            ,staffFilterSearch: ""
            ,grandTotal: 0.00
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount() {
        const fetches = [fetch(API + "getstores"), fetch(API + "getstaff"), fetch(API + "getclients&onlyactive=true"), fetch(API + "getpaymenttypes")];
        this.setState({tableLoading:true});

        Promise.all(fetches)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            this.setState({
                fetchStores:data[0].data,
                fetchStaff:data[1].data,
                fetchClients:data[2].data,
                fetchPaymentTypes:data[3].data,
            });
        });
        this.getPayments();
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    /* END React own Functions */

    /* START Handles */

    handleChangeSuggest = name => (event, { newValue }) => {
        this.setState({
            [name]: newValue,
        });
    };
    handleNumberChange = (e) => {
        const value = e.target.value > 0 ? e.target.value : 0;
        this.setState({ [e.target.id]: value, somethingWasEdited:true });
    }
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });

    handleStoreInputChange = (e) => {
        const value = e.target.value;
        sessionStorage.setItem("paymentsStoreInput", value);
        this.setState({ storeInput: value});
    }

    handlePaymentTypeChange = (e) => {
        this.setState({ paymentType: e.target.value});
    }

    handleDateInputChange = (value) => {
        this.setState({ dateInput: value });
    }

    handleClientInputValue = (sug) => {
        this.setState({clientInputId: sug.Id, somethingWasEdited:true});
    }

    handleStaffInputValue = (sug) => {
        sessionStorage.setItem("paymentsStaffInputId", sug.Id);
        sessionStorage.setItem("paymentsStaffInputName", sug.FullName);
        this.setState({staffInputId: sug.Id, somethingWasEdited:true});
    }

    handleStoreFilterChange = (e, item) => {
        let value = e.target.value;
        if(item.key==="0"){
            value=[""];
        }else{
            if (value.length > 1 && value.indexOf("") > -1)
                value.splice(value.indexOf(""), 1);

            if(!value.length)
                value = [""];
        }

        this.setState({ storeFilter: value, loading:true}, this.getPayments);
    }

    handleDateFilterChange = (value) => {
        const today = moment();
        const dateName = today.diff(value) ? "a " + value.format("DD/MM/YYYY") : "Hoje";
        this.setState({ dateFilter: value, dateName, loading:true }, this.getPayments);
    }
    handleClientFilterValue = (sug) => {
        this.setState({clientFilterId: sug.Id, loading:true}, this.getPayments);
    }

    handleStaffFilterValue = (sug) => {
        this.setState({staffFilterId: sug.Id, loading:true}, this.getPayments);
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        const value = event.target.value;
        sessionStorage.setItem("paymentsRowsPerPage", value)
        this.setState({ rowsPerPage: parseInt(value, 10) }, this.getPayments);
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSave = (e) => {
        e.preventDefault();
        if(!this.state.somethingWasEdited)
            return;

        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: false, showErrorMessage: true, dumbValidations: false })){
            const { staffInputId, clientInputId, paymentId, storeInput, dateInput, value, paymentType, notes } = this.state
                  , wrongStaff = staffInputId === "" || isNaN(staffInputId)
                  , wrongClient = false;//clientInputId==="" || isNaN(clientInputId);

            if(wrongStaff || wrongClient){
                const msg = wrongClient ? "Tem de escolher um Cliente da lista" : "Tem de escolher um Funcionário da lista";
                this.setState({ returnTitle:"Erro", returnType: 2, returnText: msg, openModal: true});
                return;
            }
            let DEFAULT_QUERY = "savepayment&paymentid=" + paymentId + "&storeid=" + storeInput + "&clientid=" + clientInputId
                                + "&staffid=" + staffInputId + "&dateinput=" + dateInput.format('YYYY-MM-DD') + "&value=" + value
                                + "&paymenttype=" + paymentType + "&notes=" + notes
                                + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

            this.setState({loading:true});
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => this.setState({
                returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro"
                , returnType: result.shortmsg === "OK" ? 1 : 2
                , returnText: result.message
                , openModal: true
                , loading:false
                , staffInputId: !isNullOrEmpty(sessionStorage.getItem("paymentsStaffInputId")) ? sessionStorage.getItem("paymentsStaffInputId") : ""
                , clientInputId: ""
                , clientInputSearch: ""
                , staffInputSearch: !isNullOrEmpty(sessionStorage.getItem("paymentsStaffInputName")) ? sessionStorage.getItem("paymentsStaffInputName") : ""
                , paymentId: "New"
                , storeInput: !isNullOrEmpty(sessionStorage.getItem("paymentsStoreInput")) ? sessionStorage.getItem("paymentsStoreInput") : "1"
                , dateInput: moment()
                , value: ""
                , paymentType: "1"
                , notes: ""
            })).then(() => {
                this.resetFields();
                this.getPayments();
            });
        }
    }

    /* END Handles */

    /* START Component Functions */

    getPayments = () => {
        const { storeFilter, clientFilterId, staffFilterId, dateFilter } = this.state;
        const { isAdmin, loginData } = this.props;
        const Payments = loginData.profile.Payments;
        let queryParams = "&getbycreatedby=" + this.props.loginData.Id;

        if((isAdmin || (Payments && Payments.viewAllPayments))){
            let storeQuery = ""
                , clientQuery = ""
                , staffQuery = ""
                , dateQuery = "";

            if(storeFilter.length >= 1 && storeFilter[0] !== "") storeQuery = "&getbystoreids=" + storeFilter.join(",");
            if(clientFilterId) clientQuery = "&getbyclientid=" + clientFilterId;
            if(staffFilterId) staffQuery = "&getbystaffid=" + staffFilterId;
            if(dateFilter) dateQuery = "&getbydate=" + dateFilter.format('YYYY-MM-DD');

            queryParams = storeQuery + clientQuery + staffQuery + dateQuery;
        }

        fetch(API + "getpayments" + queryParams)
        .then(response => response.json())
        .then(data => this.setState({
            fetchPayments: data.data.payments,
            grandTotal: data.data.totals.GrandTotal,
            loading: false
        }));
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    clearField = (field) => {
        const newStateObject = {};
        switch(field){
            case FIELD.CLIENT_INPUT:
                newStateObject.clientInputId = "";
                newStateObject.clientInputSearch = "";
                break;
            case FIELD.STAFF_INPUT:
                newStateObject.staffInputId = "";
                newStateObject.staffInputSearch = "";
                break;
            case FIELD.CLIENT_FILTER:
                newStateObject.clientFilterId = "";
                newStateObject.clientFilterSearch = "";
                break;
            case FIELD.STAFF_FILTER:
                newStateObject.staffFilterId = "";
                newStateObject.staffFilterSearch = "";
                break;
            default:
                return;
        }
        this.setState(newStateObject, this.getPayments);
    }

    updatePayment = (paymentId) => {
        fetch(API + "getpayments&getbyid="+paymentId)
        .then(response => response.json())
        .then(result => this.setState({
            loading:false
            , staffInputId: result.data.StaffId
            , clientInputId: result.data.ClientId
            , clientInputSearch: result.data.ClientFullName + " (" + result.data.ClientCellPhone + ")"
            , staffInputSearch: result.data.StaffFullName
            , paymentId: paymentId
            , storeInput: result.data.StoreId
            , dateInput: moment(result.data.PaymentDate)
            , value: result.data.PaymentValue
            , paymentType: result.data.PaymentType
            , notes: result.data.Notes
        }));
    }

    deletePayment = (paymentId) => {
        if(window.confirm("Tem a certeza que quer apagar este pagamento?")){
            this.setState({tableLoading:true});
            fetch(API + 'deletepayment&paymentid=' + paymentId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({
                    returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro"
                    , returnText: result.message
                    , openModal: true
                    , tableLoading:false
                }, () => {
                    this.resetFields();
                    this.getPayments();
                });
            });
        }
    }

    resetFields = () => {
        this.setState({
            staffInputId: !isNullOrEmpty(sessionStorage.getItem("paymentsStaffInputId")) ? sessionStorage.getItem("paymentsStaffInputId") : ""
            , clientInputId: ""
            , clientInputSearch: ""
            , staffInputSearch: !isNullOrEmpty(sessionStorage.getItem("paymentsStaffInputName")) ? sessionStorage.getItem("paymentsStaffInputName") : ""
            , paymentId: "New"
            , storeInput: !isNullOrEmpty(sessionStorage.getItem("paymentsStoreInput")) ? sessionStorage.getItem("paymentsStoreInput") : "1"
            , dateInput: moment()
            , value: ""
            , paymentType: "1"
            , notes: ""
        }, this.getPayments);
    }

    /* END Component Functions */

    /* START Renders */

    renderStoresOptions = (multiple) => {
        const stores = this.state.fetchStores;
        if(stores===null)
            return;
        const items = multiple ? [<MenuItem value="" key="0">Todas as Lojas</MenuItem>] : [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=stores.length;i<n;i++) {
            const item = multiple ?
                         <MenuItem value={stores[i].Id}
                                   key={stores[i].Id}
                                   checked={this.state.storeFilter && this.state.storeFilter.indexOf(stores[i].Id) > -1}
                                   className="insetItem">{stores[i].Name + " - " + stores[i].Shortname}
                         </MenuItem>
                         :
                         <MenuItem value={stores[i].Id} key={stores[i].Id}>
                            {<div><div className="smallColorDiv" style={{backgroundColor: stores[i].Color}}></div> <span>{stores[i].Name + " - " + stores[i].Shortname}</span></div>}
                         </MenuItem>;

            items.push(item);
        }
        return items;
    }

    renderPaymentOptions = (e) => {
        const payments = this.state.fetchPaymentTypes;
        if(payments===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=payments.length;i<n;i++) {
            items.push(<MenuItem value={payments[i].Id}
                                 key={payments[i].Id}>
                                    {<div><div className="smallImage"><img src={payments[i].Image} alt={payments[i].Shortname} /></div> <span>{payments[i].Name}</span></div>}
                       </MenuItem>);
        }
        return items;
    }

    /* END Renders */

    render() {
        const { isAdmin, loginData } = this.props;
        const { 
            editable
            , dateFilter
            , staffFilterId
            , clientFilterId
            , storeFilter
            , order
            , orderBy
            , rowsPerPage
            , page
        } = this.state;

        const { dateName, fetchPayments } = this.state
              , optsStores = this.renderStoresOptions()
              , optsFilterStores = this.renderStoresOptions(true)
              , optsPayments = this.renderPaymentOptions()
              , loadingClass = this.state.loading ? " ajaxLoading" : ""
              , Payments = loginData.profile.Payments
              , paymentCount = fetchPayments ? fetchPayments.length : 1
              , pathStaff = staffFilterId ? "/" + staffFilterId : ""
              , pathClient = clientFilterId ? "/" + clientFilterId : ""
              , pathStore = storeFilter && storeFilter[0] ? "/" + storeFilter : ""
              , headerRows = [
                  { id: 'StoreName', active: true, numeric: false, label: 'Loja' },
                  { id: 'ClientFullName', numeric: false, label: 'Cliente' },
                  { id: 'StaffFullName', numeric: false, label: 'Funcionário' },
                  { id: 'PaymentDate', numeric: false, className: 'midHeader', label: 'Data' },
                  { id: 'DateCreated', numeric: false, className: 'midHeader', label: 'Data Criação' },
                  { id: 'PaymentType', numeric: false, className: 'midSmallHeader', label: 'Método' },
                  { id: 'PaymentValue', numeric: false, className: 'midHeader', label: 'Valor' },
                  { id: 'actions', notSortable: true, className: 'midHeader', label: 'Ações' },
              ]
              , printProps = { 
                  pathname:"/PrintPayments/"+dateFilter+pathStaff+pathClient+pathStore+"/"+order+"/"+orderBy+"/"+rowsPerPage+"/"+page};
        let pageTotal = 0;

        return (
            <div id="paymentsPage" className="addEditPage">
                <div>
                    { (isAdmin || (Payments && Payments.ADD)) && 
                        <div>
                            <div className="pageHeader">
                                <h1><i className="far fa-money-bill-alt"></i> Registar Pagamentos</h1>
                            </div>
                            <form className="row form" ref="editForm" onSubmit={this.handleSave}>
                                <div className="fieldHolder required selectField col-md-3">
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="storeInput">Clínica</InputLabel>
                                        <Select id="storeInput"
                                                name="storeInput"
                                                value={this.state.storeInput}
                                                onChange={this.handleStoreInputChange}
                                                disabled={!editable}
                                                data-empty-error-message="Este campo não pode estar vazio">
                                        {optsStores}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className={"fieldHolder col-12 col-md-4 clientsHolder required"}>
                                    <Tooltip
                                        title={"Limpar campo Cliente"}
                                        enterDelay={200}>
                                        <button type="button" className="simpleBtn actionButton danger clearField" onClick={() => this.clearField(FIELD.CLIENT_INPUT)}><i className="fa fa-times"></i></button>
                                    </Tooltip>
                                    <AutoSug
                                        sugValue={this.handleClientInputValue}
                                        sugInputValue={'suggestion.FullName'}
                                        sug={'suggestion.FullName + " ("+suggestion.CellPhone+")"'}
                                        data={this.state.fetchClients}
                                        filter={filters}
                                        inputProps={{
                                            fullWidth: true,
                                            placeholder: 'Cliente',
                                            label: "Cliente",
                                            value: this.state.clientFullName || this.state.clientInputSearch,
                                            onChange: this.handleChangeSuggest('clientInputSearch'),
                                            disabled: !editable || this.state.blockClientService,
                                        }}
                                    />
                                </div>
                                <div className={"fieldHolder col-12 col-md-3 staffHolder required"}>
                                    <Tooltip
                                        title={"Limpar campo Funcionário"}
                                        enterDelay={200}>
                                        <button type="button" className="simpleBtn actionButton danger clearField" onClick={() => this.clearField(FIELD.STAFF_INPUT)}><i className="fa fa-times"></i></button>
                                    </Tooltip>
                                    <AutoSug
                                        sugValue={this.handleStaffInputValue}
                                        sugInputValue={'suggestion.FullName'}
                                        sug={'suggestion.FullName + " ("+suggestion.CellPhone+")"'}
                                        data={this.state.fetchStaff}
                                        filter={filters}
                                        inputProps={{
                                            fullWidth: true,
                                            placeholder: 'Funcionário',
                                            label: "Funcionário",
                                            value: this.state.staffInputSearch,
                                            onChange: this.handleChangeSuggest('staffInputSearch'),
                                            disabled: !editable
                                        }}
                                    />
                                </div>
                                <div className="fieldHolder col-md-2">
                                    <DatePicker
                                    fullWidth
                                    id="dateInput"
                                    label="Data"
                                    format="DD/MM/YYYY"
                                    placeholder="Datao"
                                    disabled={!editable}
                                    value={this.state.dateInput || null}
                                    locale="pt-PT"
                                    onChange={this.handleDateInputChange}
                                />
                            </div>
                            <div className="fieldHolder required selectField col-md-3">
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="paymentType">Tipo de Pagamento</InputLabel>
                                    <Select id="paymentType"
                                            name="paymentType"
                                            value={this.state.paymentType}
                                            onChange={this.handlePaymentTypeChange}
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio">
                                        {optsPayments}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-md-3">
                                <div className="fieldHolder moneyHolder required">
                                    <TextField fullWidth
                                                id="value"
                                                value={this.state.value}
                                                onChange={this.handleNumberChange}
                                                onBlur={this.handlePriceWithVAT}
                                                label="Valor Pago"
                                                disabled={!editable}
                                                data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                            </div>
                            <div className="fieldHolder col-md-6">
                                <TextField fullWidth
                                            id="notes"
                                            value={this.state.notes}
                                            onChange={this.handleFieldChange}
                                            disabled={!editable}
                                            multiline
                                            rows={4}
                                            label="Observações" />
                            </div>
                            <div className="col-12 buttonsHolder">
                                <Button onClick={this.resetFields} variant="contained" className="defaultButton">Cancelar</Button>
                                { (isAdmin || Payments.DEL) && this.state.paymentId !== "New" && <Button onClick={() => this.deletePayment(this.state.paymentId)} className="button button-danger" variant="contained">Apagar Pagamento</Button>}
                                { editable && <Button type="submit" className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                            </div>
                        </form>
                    </div>
                    }
                    <div className="pageHeader normalMarginTop">
                        <h1><i className="fa fa-cash-register"></i> Pagamentos {dateName}
                                { (isAdmin || loginData.profile.Payments.canPrintPayments) && 
                                    <span className="float-right printHolder">
                                        <NavLink type="button" className="simpleBtn actionButton success" to={printProps} target="_blank" title={"Imprimir pagamentos"}>Imprimir <i className="fa fa-print fa-2x"></i></NavLink>
                                    </span>
                                }</h1>
                    </div>
                    { (isAdmin || (Payments && Payments.filters)) && 
                        <form className="row form">
                            <div className="fieldHolder selectField col-md-3">
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="storeFilter">Filtrar por Clínica</InputLabel>
                                    <Select id="storeFilter"
                                            name="storeFilter"
                                            value={storeFilter}
                                            onChange={this.handleStoreFilterChange}
                                            multiple
                                            disabled={!editable}>
                                      {optsFilterStores}
                                    </Select>
                                </FormControl>
                            </div>
                            {this.state.fetchClients!=null &&
                                <div className={"fieldHolder col-12 col-md-4 clientsHolder"}>
                                    <Tooltip
                                        title={"Limpar filtro Cliente"}
                                        enterDelay={200}>
                                        <button type="button" className="simpleBtn actionButton danger clearField" onClick={() => this.clearField(FIELD.CLIENT_FILTER)}><i className="fa fa-times"></i></button>
                                    </Tooltip>
                                    <AutoSug
                                        sugValue={this.handleClientFilterValue}
                                        sugInputValue={'suggestion.FullName'}
                                        sug={'suggestion.FullName + " ("+suggestion.CellPhone+")"'}
                                        data={this.state.fetchClients}
                                        filter={filters}
                                        inputProps={{
                                            fullWidth: true,
                                            placeholder: 'Filtrar por Cliente',
                                            label: "Filtrar por Cliente",
                                            value: this.state.clientFullName || this.state.clientFilterSearch,
                                            onChange: this.handleChangeSuggest('clientFilterSearch'),
                                            disabled: !editable || this.state.blockClientService,
                                        }}
                                    />
                               </div>
                            }
                            {this.state.fetchStaff !== null &&
                                <div className={"fieldHolder col-12 col-md-3 staffHolder"}>
                                    <Tooltip
                                        title={"Limpar filtro Funcionário"}
                                        enterDelay={200}>
                                        <button type="button" className="simpleBtn actionButton danger clearField" onClick={() => this.clearField(FIELD.STAFF_FILTER)}><i className="fa fa-times"></i></button>
                                    </Tooltip>
                                    <AutoSug
                                        sugValue={this.handleStaffFilterValue}
                                        sugInputValue={'suggestion.FullName'}
                                        sug={'suggestion.FullName + " ("+suggestion.CellPhone+")"'}
                                        data={this.state.fetchStaff}
                                        filter={filters}
                                        inputProps={{
                                           fullWidth: true,
                                           placeholder: 'Filtrar por Funcionário',
                                           label: "Filtrar por Funcionário",
                                           value: this.state.staffFilterSearch,
                                           onChange: this.handleChangeSuggest('staffFilterSearch'),
                                           disabled: !editable || this.state.fetchStaff.length === 0
                                        }}
                                    />
                                </div>
                            }
                            <div className="fieldHolder col-md-2">
                                <DatePicker
                                    fullWidth
                                    id="dateFilter"
                                    label="Filtrar por data"
                                    format="DD/MM/YYYY"
                                    placeholder="Data de Envio"
                                    disabled={!editable}
                                    value={this.state.dateFilter || null}
                                    locale="pt-PT"
                                    onChange={this.handleDateFilterChange}
                                />
                            </div>
                        </form>
                    }
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={paymentCount}>
                        </EnhancedTableHead>
                        <TableBody>
                            {fetchPayments && stableSort(fetchPayments, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(payment => { pageTotal += parseFloat(payment.PaymentValue)
                                    return (
                            <TableRow key={payment.Id} className="tableRow" ref={"payment_" + payment.Id}>
                                <TableCell data-title="Loja" className="tableCell"><div className="smallColorDiv" style={{backgroundColor: payment.StoreColor}}></div> {payment.StoreName}</TableCell>
                                <TableCell data-title="Cliente" className="tableCell">
                                    <Tooltip
                                        title={payment.ClientFullName + " (" + payment.ClientCellPhone + ")"}
                                        enterDelay={200}>
                                        <span><NavLink to={"/Clients/"+payment.ClientId}>{payment.ClientFirstName} {payment.ClientLastName}</NavLink></span>
                                    </Tooltip>
                                    {
                                        payment.ClientGlobalNotes && (isAdmin || Payments.globalNotes) &&
                                        <Tooltip
                                            title={payment.ClientGlobalNotes}
                                            enterDelay={200}>
                                            <span><button className="simpleBtn danger globalNotesWarning" onClick={() => this.openModal({ title: "Notas do Cliente", text: payment.ClientGlobalNotes })}><i className="far fa-sticky-note fa-2x"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell>
                                <TableCell data-title="Funcionário" className="tableCell">{payment.StaffFullName}</TableCell>
                                <TableCell data-title="Data" className="tableCell midCell">{moment(payment.PaymentDate).format("DD-MM-YYYY")}</TableCell>
                                <TableCell data-title="Data Criação" className="tableCell midCell">
                                    <Tooltip
                                        title={"Criado em " + moment(payment.DateCreated).format("DD-MM-YYYY") + " pelo utilizador " + payment.UserName + " ("+ payment.UserUserName +")"}
                                        enterDelay={200}>
                                        <b>{moment(payment.DateCreated).format("DD-MM-YYYY HH:mm")}</b>
                                    </Tooltip>
                                </TableCell>
                                <TableCell data-title="Método" className="tableCell midSmallCell">
                                    <Tooltip
                                        title={"Método de pagamento usado: " + payment.PaymentTypeName}
                                        enterDelay={200}>
                                        <b>{payment.PaymentTypeShortname}</b>
                                    </Tooltip>
                                </TableCell>
                                <TableCell data-title="Valor" className="tableCell midCell">
                                    <Tooltip
                                        title={"Tipo de pagamento utilizado foi " + payment.PaymentTypeName + ". Criador original: "+ payment.OriginalUserName +" ("+ payment.OriginalUserUserName + "), última modificação: " + payment.UserName +" ("+ payment.UserUserName +")" }
                                        enterDelay={200}>
                                        <b>{parseFloat(payment.PaymentValue).toFixed(2) + "€"}</b>
                                    </Tooltip>
                                </TableCell>
                                <TableCell data-title="Ações" className="tableCell midCell actions" data-row-id={payment.Id}>
                                    { payment.Notes &&
                                        <button type="button" className="simpleBtn actionButton success">
                                            <Tooltip
                                                title={"Observações: " + payment.Notes}
                                                enterDelay={200}>
                                                <span><i className="fa fa-eye"></i></span>
                                            </Tooltip>
                                        </button>
                                    }
                                    { ((isAdmin || (Payments && Payments.updatePayments)) || this.props.loginData.Id === payment.UserId) &&
                                        <button type="button" className="simpleBtn actionButton warning" onClick={() => this.updatePayment(payment.Id)}>
                                            <Tooltip
                                                title={"Editar Pagamento"}
                                                enterDelay={200}>
                                                <span><i className="fa fa-pencil-alt"></i></span>
                                            </Tooltip>
                                        </button>
                                    }
                                    { (isAdmin || (Payments && Payments.DEL)) && 
                                        <button type="button" className="simpleBtn actionButton danger" onClick={() => this.deletePayment(payment.Id)}>
                                            <Tooltip
                                                title={"Apagar Pagamento"}
                                                enterDelay={200}>
                                                <span><i className="fa fa-times"></i></span>
                                            </Tooltip>
                                        </button>
                                    }
                                </TableCell>
                            </TableRow>
                        )})}
                        { (isAdmin || (Payments && Payments.viewTotals)) && 
                            <TableRow key="999999" className="tableRow">
                                <TableCell className="tableCell" colSpan="6"></TableCell>
                                <TableCell className="tableCell totalsRow"><h4>Total Página</h4><p>{parseFloat(pageTotal).toFixed(2) + "€"}</p></TableCell>
                                <TableCell className="tableCell totalsRow"><h4>Valor total</h4><p>{this.state.grandTotal + "€"}</p></TableCell>
                            </TableRow>
                        }
                        </TableBody>
                    </Table>
				</div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            component="div"
                            count={paymentCount}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Payments;
